"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getShippingWeight = void 0;
const getShippingWeight = (product, dimFactor = 139) => {
    if (!product || !product.weight || !product.width || !product.length || !product.height) {
        return 1;
    }
    const shippingWeight = Math.max((product.length * product.width * product.height) / dimFactor, product.weight);
    return shippingWeight > 1 ? Math.ceil(shippingWeight) : Math.ceil(shippingWeight / 0.25) * 0.25;
};
exports.getShippingWeight = getShippingWeight;
//# sourceMappingURL=ShippingWeightCalculator.js.map